"use client";

import React from "react";

import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { Lock, Info } from "lucide-react";
import sendIcon from "../assets/images/sendIcon.svg";
import CurrencyFormatter from "../utils/currencyFormatter";
import { FormattedDate } from "../utils/dateFormatter";

const PaymentDetails = ({ transactionData, onDone }) => {
  const date = new Date(transactionData?.transactionDate);
  const formatter = new CurrencyFormatter();
  const dateFormat = new FormattedDate();
  const simpleFormat = dateFormat.simpleFormat(
    transactionData?.transactionDate
  );
  const formattedDate = date.toLocaleDateString("en-ZA", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  const formattedTime = date.toLocaleTimeString("en-ZA", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

  const handleDone = () => {
    if (onDone) {
      onDone();
    }
  };

  return (
    <Card className="w-full p-8 bg-white rounded-2xl border border-[#EBE9EF] !shadow-none relative">
      <div className="text-center px-6 pt-8"></div>

      <CardContent className="px-6 mt-6 w-full">
        <h3 className="text-base font-semibold text-gray-700 mb-3">
          Transaction History
        </h3>
        <div className="px-6 py-4 rounded-2xl mt-4 mb-3  bg-gray-50 flex items-center justify-between">
          <div className="flex items-center justify-center">
            <div className="mr-3">
              <img src={sendIcon} alt="" />
            </div>
            <div className="">
              <p className="text-[16px] text-[#423E51] font-semibold">
                Eighty Eight Pay
              </p>
              <p className="text-[14px] text-[#6D6584] font-normal">
                {simpleFormat}
              </p>
            </div>
          </div>
          <div className="font-semibold">
            {formatter.format(
              transactionData?.amount?.$numberDecimal,
              transactionData?.currency
            )}
          </div>
        </div>
        <div className="border rounded-lg divide-y">
          <div className="p-4 flex justify-between">
            <span className="text-sm text-gray-700">Amount</span>
            <span className="text-sm font-medium text-gray-800">
              {formatter.format(
                transactionData?.amount?.$numberDecimal,
                transactionData?.currency
              )}
            </span>
          </div>
          <div className="p-4 flex justify-between">
            <span className="text-sm text-gray-700">Pay to</span>
            <span className="text-sm font-medium text-gray-800">
              {transactionData?.receiverPayId ||
                transactionData?.receiverEmail ||
                transactionData?.receiverPhone}
            </span>
          </div>
          <div className="p-4 flex justify-between">
            <span className="text-sm text-gray-700">Their Reference</span>
            <span className="text-sm font-medium text-gray-800">
              {transactionData?.receiverReference}
            </span>
          </div>
          <div className="p-4 flex justify-between">
            <span className="text-sm text-gray-700">Your Reference</span>
            <span className="text-sm font-medium text-gray-800">
              {transactionData?.senderReference}
            </span>
          </div>
          <div className="p-4 flex justify-between">
            <span className="text-sm text-gray-700">Time stamp</span>
            <span className="text-sm font-medium text-gray-800">
              <p className="text-md font-bold">{formattedDate}</p>
              <p className="text-sm">{formattedTime}</p>
            </span>
          </div>
          <div className="p-4 flex justify-between">
            <span className="text-sm text-gray-700">Transaction ID</span>
            <span className="text-sm font-medium text-gray-800">
              {transactionData?.transactionId}
            </span>
          </div>
          <div className="p-4 flex justify-between items-center">
            <span className="flex items-center gap-1 text-sm text-gray-700">
              Service charge
              <Info size={14} className="text-gray-500" />
            </span>
            <span className="text-sm font-medium text-gray-800">
              {/* {transactionData?.serviceFee["$numberDecimal"]} */}0
            </span>
          </div>
          <div className="p-4 flex justify-between">
            <span className="text-sm text-gray-700">Total Cost</span>
            <span className="text-sm font-medium text-gray-800">
              {formatter.format(
                transactionData?.totalAmount?.$numberDecimal,
                transactionData?.currency
              )}
            </span>
          </div>
        </div>
      </CardContent>

      {/* Footer actions */}
      <div className="flex justify-center w-full">
        <div className="flex items-center justify-center mr-10 w-[100px] gap-4">
          <Button
            onClick={handleDone}
            className={
              "py-5 px-10 text-sm font-bold text-white rounded-full bg-gradient-to-tr from-purple-500 to-rose-500 hover:opacity-90"
            }
          >
            Done
          </Button>
        </div>
      </div>

      {/* Bottom lock label */}
      <div className="flex items-center justify-center gap-1 text-sm text-gray-500 pb-6">
        <Lock size={12} />
        <p>Secured by 80Eight</p>
      </div>
    </Card>
  );
};

export default PaymentDetails;
